import { render, staticRenderFns } from "./SafetySidebar.vue?vue&type=template&id=68791f2b&scoped=true&"
import script from "./SafetySidebar.vue?vue&type=script&lang=js&"
export * from "./SafetySidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68791f2b",
  null
  
)

export default component.exports